<!--
 * @Description: 商品卡片
 * @Author: WuPuyi
 * @LastEditors: ChenXueLin
 * @Date: 2021-05-27 17:01:15
 * @LastEditTime: 2021-08-06 17:01:39
 * @FilePath: \e3-channel-client\src\e3-channel-client\views\purchase\components\goodsCard.vue
-->
<template>
  <div class="goods-card">
    <el-checkbox
      v-if="showCheck"
      v-model="goods.checked"
      @change="handleCheckChange($event, goods)"
    ></el-checkbox>
    <e6-image
      :src="goods.downloadUrl ? goods.downloadUrl[0] || '' : ''"
      class="goods-card__img"
    ></e6-image>
    <div class="goods-card__content">
      <div class="goods-card-category">
        <h2 class="goods-card-category--content">
          {{ goods.firstClassName }} | {{ goods.secondClassName }} |
          {{ goods.thirdClassName }}
        </h2>
        <!-- TODO: 快速配件暂时不上，20210325 -->
        <!-- <el-button
            type="text"
            @click="handleShowQuickMatch"
            v-if="item.isInstall"
            >快速搭配配件</el-button
          > -->
      </div>
      <div class="goods-card-introduction" ref="goodsIntro">
        <p
          :class="[isShowIntroBtn ? 'goods-card-pr-15' : '']"
          ref="goodsIntroInner"
        >
          {{ goods.functionalOrientation }}
          <i
            class="e6-icon-arrow-b_line"
            v-if="isShowIntroBtn && !isShowIntro"
            @click="handleShowGoodsIntro"
          ></i>
          <i
            class="e6-icon-arrow-t_line"
            v-if="isShowIntroBtn && isShowIntro"
            @click="handleHiddenGoodsIntro"
          ></i>
        </p>
      </div>
      <div class="goods-card-description" ref="goodsDesc">
        <p
          :class="[isShowDescBtn ? 'goods-card-pr-15' : '']"
          ref="goodsDescInner"
        >
          {{ goods.productDescription }}
          <i
            class="e6-icon-arrow-b_line"
            v-if="isShowDescBtn && !isShowDesc"
            @click="handleShowGoodsDesc"
          ></i>
          <i
            class="e6-icon-arrow-t_line"
            v-if="isShowDescBtn && isShowDesc"
            @click="handleHiddenGoodsDesc"
          ></i>
        </p>
      </div>
      <div class="goods-card-select">
        <span class="goods-card-select--label">购买数量</span>
        <input-number
          v-model="goods.purchaseQuantity"
          :min="minQuantity"
          @change="handlePurchaseQuantityChange($event, goods)"
        ></input-number>
      </div>
      <div class="goods-card-footer">
        <div class="goods-card-price">
          <span>￥</span>{{ goods.equipBasePrice | formatNumber }}
        </div>
        <div class="goods-card-operation" v-if="showBuy">
          <el-button class="reset" @click="handleBuyNow(goods)" v-has="105210"
            >立即购买</el-button
          >
          <el-button
            type="primary"
            @click="handleAddShoppingCar(goods)"
            v-has="105211"
            >加入购物车</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inputNumber from "e3-channel-client/components/inputNumber";
import base from "e6-base-carrier-3.0/mixins/base";
export default {
  name: "goodsCard",
  mixins: [base],
  components: {
    inputNumber
  },
  props: {
    goods: {
      type: Object,
      default() {
        return {};
      }
    },
    // 商品index
    goodsIndex: {
      type: Number,
      default: 0
    },
    // 是否显示选择
    showCheck: {
      type: Boolean,
      default: false
    },
    // 商品最小数量
    minQuantity: {
      type: Number,
      default: 0
    },
    // 是否展示立即购买按钮
    showBuy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowIntroBtn: false,
      introClientHeight: 0,
      introInnerClientHeight: 0,
      isShowIntro: false,
      isShowDescBtn: false,
      descClientHeight: 0,
      descInnerClientHeight: 0,
      isShowDesc: false
    };
  },
  mounted() {
    this.init();
    window.addEventListener("resize", this.init);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.init);
  },
  filters: {
    formatNumber(str) {
      if (str) {
        return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "0";
      }
    }
  },
  methods: {
    init() {
      this.handleShowIntroBtn();
      this.handleShowDescBtn();
    },
    // 选择改变
    handleCheckChange(val, goods) {
      this.$emit("checkChange", val, goods);
    },
    // 处理购买数量改变
    handlePurchaseQuantityChange: _.debounce(function(val, goods) {
      this.$emit("quantityChange", val, goods, this.goodsIndex);
    }, 300),
    // 立即购买
    handleBuyNow(goods) {
      this.$emit("buyNow", goods);
    },
    // 加入购物车
    handleAddShoppingCar(goods) {
      this.$emit("addShoppingCar", goods, this.goodsIndex);
    },
    // 展示介绍按钮
    handleShowIntroBtn() {
      this.$nextTick(() => {
        let introDom = this.$refs.goodsIntro;
        let introInnerDom = this.$refs.goodsIntroInner;
        this.isShowIntroBtn =
          introDom.clientHeight < introInnerDom.clientHeight;
        this.introClientHeight = introDom.clientHeight;
        this.introInnerClientHeight = introInnerDom.clientHeight;
      });
    },
    // 展示描述
    handleShowGoodsIntro() {
      let introDom = this.$refs.goodsIntro;
      introDom.style.height = `${this.introInnerClientHeight}px`;
      this.isShowIntro = true;
    },
    // 收起描述
    handleHiddenGoodsIntro() {
      let introDom = this.$refs.goodsIntro;
      introDom.style.height = `${this.introClientHeight}px`;
      this.isShowIntro = false;
    },
    // 展示介绍按钮
    handleShowDescBtn() {
      this.$nextTick(() => {
        let descDom = this.$refs.goodsDesc;
        let descInnerDom = this.$refs.goodsDescInner;
        this.isShowDescBtn = descDom.clientHeight < descInnerDom.clientHeight;
        this.descClientHeight = descDom.clientHeight;
        this.descInnerClientHeight = descInnerDom.clientHeight;
      });
    },
    // 展示描述
    handleShowGoodsDesc() {
      let descDom = this.$refs.goodsDesc;
      descDom.style.height = `${this.descInnerClientHeight}px`;
      this.isShowDesc = true;
    },
    // 收起描述
    handleHiddenGoodsDesc() {
      let descDom = this.$refs.goodsDesc;
      descDom.style.height = `${this.descClientHeight}px`;
      this.isShowDesc = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.goods-card {
  display: flex;
  align-items: center;
  min-height: 170px;
  padding: 15px 0;
  border-bottom: 2px solid #f2f4f8;
  &__img {
    display: block;
    width: 170px;
    height: 170px;
    border-radius: 6px;
    margin: 0 20px 0 14px;
    /deep/ .el-image__inner {
      border-radius: 6px;
    }
  }
  &__content {
    width: calc(100% - 218px);
    min-height: 170px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .goods-card-category {
    height: 40px;
    display: flex;
    justify-content: space-between;
    &--content {
      font-weight: normal;
      font-size: 16px;
      line-height: 40px;
      color: #2b2c2e;
    }
  }
  .goods-card-pr-15 {
    padding-right: 15px;
  }
  .goods-card-introduction {
    width: 100%;
    height: 38px;
    line-height: 38px;
    color: #48494c;
    font-size: 16px;
    overflow: hidden;
    transition: height 0.3s ease-out 0s;
    & > {
      p {
        position: relative;
      }
    }
    p > i {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 14px;
      cursor: pointer;
      color: #46bfea;
    }
  }
  .goods-card-description {
    height: 18px;
    line-height: 18px;
    font-size: 14px;
    color: #898c91;
    overflow: hidden;
    transition: height 0.3s ease-out 0s;
    & > {
      p {
        position: relative;
      }
    }
    p > i {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 14px;
      cursor: pointer;
      color: #46bfea;
    }
  }
  .goods-card-select {
    height: 33px;
    display: flex;
    justify-content: flex-end;
    &--label {
      font-size: 14px;
      color: #898c91;
      line-height: 33px;
      margin-right: 17px;
    }
    /deep/ .input-number {
      .el-input-number {
        height: 33px;
        line-height: 33px;
        width: 60px;
        .el-input__inner {
          height: 33px;
          line-height: 33px;
          width: 60px;
        }
      }
    }
  }
  .goods-card-footer {
    height: 32px;
    display: flex;
    justify-content: space-between;
    .goods-card-price {
      font-size: 24px;
      color: #e6a23c;
      & > span {
        font-size: 18px;
      }
    }
    .goods-card-operation {
      /deep/ .el-button {
        height: 32px;
      }
    }
  }
}
</style>
